<template>
  <j-modal
    :maskClosable="true"
    :width="drawerWidth"
    placement="right"
    :title="title"
    :closable="true"
    @close="handleCancel"
    @cancel="handleCancel"
    :visible="visible"
    :footer="null"
    :fullscreen.sync="modal.fullscreen" 
    cancelText="确定"
    >
    <div style="display:flex;padding:0 0 0 10%">
       <a-form-model-item :label-col="labelCol" :wrapper-col="wrapperCol" label="流程节点" style="width:100%">
        <a-select v-model="stpeId" style="width:200px;">
            <a-select-option value="">--请选择--</a-select-option>
            <a-select-option v-for="(item, key) in flowStepList" :key="key" :value="item.id">{{item.step}}-{{item.stepName}}</a-select-option>
        </a-select>
        </a-form-model-item>
    </div>
    <div style="text-align: center; margin-top: 20px">
      <a-button
        v-if="buttonStatu"
        @click="handleOk"
        type="primary"
        slot="extra"
        style="width: 100px; height: 30px">提交</a-button>
      </div>
    </j-modal>
  
</template>


<script>
import '@/assets/less/TableExpand.less'
import { httpAction } from '@/api/manage'

export default {
  name: 'LcsjgWp',
  components: {
    },
  data() {
    return {
      title: '选择节点',
      visible: false,
      modal: {
        fullscreen: false,
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      stpeId:"",
      flowId:"",
      drawerWidth:1000,
      indexStyle: 1,
      flowStepList: [],
      comments: '',
      buttonStatu: true,
      processType: '1',
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      url: {
        toJump: '/okflow/flow-data/list/list-flowStep',
        doJump: '/okflow/flow-data/jump'
      },
    }
  },
  methods: {
    toTz(record)  {
      this.stpeId="";
      this.flowStepList=[];
      this.visible = true;
      this.flowId=record.id;
      httpAction(this.url.toJump+"?flowId="+record.id,null,'get').then((res)=>{
        this.flowStepList = res;
      })
    },
    close () {
      this.visible = false;
      this.$emit('close');
    },
    handleCancel () {
      this.close()
    },
    handleOk(){
      if(this.stpeId==''){
        this.$message.warning("请选择跳转流程节点！");
        return;
      }
      httpAction(this.url.doJump+"?flowId="+this.flowId+"&stpeId="+this.stpeId,null,'post').then((res)=>{
      this.$message.warning(res.message);
        this.close();
        //更新代办list
        this.$emit('updataList')
      })
    }

  }
}

</script>

<style>
  .hszt{
    color:#b5b0b0;
  }
</style>